import { createAction } from '../../../core/helpers'

import { FETCH_INGREDIENT_SPECIAL_CASES } from '../action-types'

const cleanupFetchIngredientSpecialCases = createAction(
  FETCH_INGREDIENT_SPECIAL_CASES.CLEANUP,
)

export default cleanupFetchIngredientSpecialCases
